module.exports = __webpack_public_path__ + "static/img/track_spanish_blue.b9f15593.png";